import { useState } from "react";
import { coverUrl } from "@/lib/cover";
import type { MixSummary } from "@/types/types";

/** Spotify-style generated-playlist artwork, drawn in CSS instead of baked
 *  images: Mix du jour = artist photo + coloured label band, the weekly
 *  drops = duotone photo + big title, daylist = time-of-day gradient. */
export function MixCover({ mix, size }: { mix: MixSummary; size?: number }) {
  const [err, setErr] = useState(false);
  const photo = !err && mix.cover_url ? coverUrl(mix.cover_url, 500) : "";
  const [g1, g2] = mix.gradient && mix.gradient.length >= 2 ? mix.gradient : [mix.color, "#121212"];
  const style = {
    "--mix-c": mix.color, "--mix-g1": g1, "--mix-g2": g2,
    ...(size ? { width: size, height: size, minWidth: size } : {}),
  } as React.CSSProperties;

  if (mix.kind === "daylist") {
    return (
      <div className="mix-cover mix-daylist" style={style} aria-label={mix.title}>
        <span className="mix-blob a" /><span className="mix-blob b" />
        <span className="mix-daylist-name">daylist</span>
        <span className="mix-daylist-sub">{mix.subtitle}</span>
      </div>
    );
  }

  if (mix.kind === "daily") {
    return (
      <div className="mix-cover mix-daily" style={style} aria-label={mix.title}>
        {photo
          ? <img src={photo} alt="" loading="lazy" decoding="async" onError={() => setErr(true)} />
          : <span className="mix-fallback" />}
        <span className="mix-tint" />
        <span className="mix-mark">S</span>
        <span className="mix-band">{mix.short}</span>
      </div>
    );
  }

  return (
    <div className={`mix-cover mix-weekly mix-${mix.kind}`} style={style} aria-label={mix.title}>
      {photo
        ? <img src={photo} alt="" loading="lazy" decoding="async" onError={() => setErr(true)} />
        : <span className="mix-fallback" />}
      <span className="mix-duo" />
      <span className="mix-mark">S</span>
      <span className="mix-big">{mix.short}</span>
    </div>
  );
}
